export default "__VITE_ASSET__yj6dcxzp__"